// extracted by mini-css-extract-plugin
export var header = "TopMenu-module--header--cd0ed";
export var headerContainer = "TopMenu-module--header-container--0fc60";
export var links = "TopMenu-module--links--777f0";
export var separator = "TopMenu-module--separator--5dce1";